/**
 * Detect if app changes to success page
 * If so, scroll user back to top of the page
 * @returns observer
 */
const MyProductCaresObserver = () => {
  // #mpr-root is the app's root element, injected by an app block
  const mpcAppRoot = document.getElementById('mpr-root')
  if (!mpcAppRoot) { return }

  const observer = new MutationObserver(() => {
    // .mpr-success-wrapper is an element that only renders on success
    const printButton = mpcAppRoot.querySelector('.mpr-success-wrapper')
    if (!printButton) { return }
    window.scrollTo(0, 0);
    observer.disconnect()
  })

  observer.observe(mpcAppRoot, {
    childList: true,
    subtree: true
  })

  return observer
}

// Run MyProductCaresObserver function only after content is loaded
window.addEventListener('DOMContentLoaded', MyProductCaresObserver)

